import React from "react";
import { connect } from "react-redux";

import { LeftArrowIcon } from "@nens/ranalib";

import { setActiveToolNone } from "../state/mainGui";

interface Props {
  setActiveToolNone: () => void;
}

const CollapseArrowButton: React.FC<Props> = (props) => {
  return <LeftArrowIcon onClick={props.setActiveToolNone} role="button" />;
};

export default connect(null, {
  setActiveToolNone,
})(CollapseArrowButton);
